<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('downloadTempFile.title') }}</span>
            <div>
              <el-button type="text" @click="_queryDownloadTempFileMethod()">
                {{ $t('downloadTempFile.refresh') }}
              </el-button>
            </div>
          </div>
          <div class="table-container">
            <el-table
              :data="downloadTempFileInfo.files"
              style="width: 100%"
              border
              stripe
            >
              <el-table-column
                prop="name"
                :label="$t('downloadTempFile.name')"
                align="center"
              />
              <el-table-column
                prop="fileTypeName"
                :label="$t('downloadTempFile.fileType')"
                align="center"
              />
              <el-table-column
                prop="downloadUserName"
                :label="$t('downloadTempFile.downloader')"
                align="center"
              />
              <el-table-column
                prop="createTime"
                :label="$t('downloadTempFile.downloadTime')"
                align="center"
              />
              <el-table-column
                prop="stateName"
                :label="$t('downloadTempFile.status')"
                align="center"
              />
              <el-table-column
                prop="remark"
                :label="$t('downloadTempFile.remark')"
                align="center"
              />
              <el-table-column
                :label="$t('downloadTempFile.operation')"
                align="center"
                width="180"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.state === '3003'"
                    size="mini"
                    @click="_downLoadFile(scope.row)"
                  >
                    {{ $t('downloadTempFile.download') }}
                  </el-button>
                  <el-button
                    v-if="scope.row.state === '3003' || scope.row.state === '4004'"
                    size="mini"
                    type="danger"
                    @click="_openDeleteFileModel(scope.row)"
                  >
                    {{ $t('downloadTempFile.delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-container">
              <el-pagination
                background
                layout="total, prev, pager, next"
                :total="downloadTempFileInfo.total"
                :page-size="pageSize"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <delete-download-temp-file ref="deleteDialog" @refresh="_listFiles" />
  </div>
</template>

<script>
import { listUserDownloadFile } from '@/api/property/downloadTempFileApi'
import DeleteDownloadTempFile from '@/components/property/deleteDownloadTempFile/deleteDownloadTempFile'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DownloadTempFile',
  components: {
    DeleteDownloadTempFile
  },
  data() {
    return {
      downloadTempFileInfo: {
        files: [],
        total: 0,
        conditions: {
          fileType: '',
          shopId: ''
        }
      },
      pageSize: 10,
      currentPage: 1
    }
  },
  created() {
    this.downloadTempFileInfo.conditions.shopId = getShopId()
    this.downloadTempFileInfo.conditions.fileType = this.$route.query.fileType
    this._listFiles(1, this.pageSize)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._listFiles(val, this.pageSize)
    },
    async _listFiles(page, rows) {
      try {
        const params = {
          ...this.downloadTempFileInfo.conditions,
          page,
          row: rows
        }
        const res = await listUserDownloadFile(params)
        this.downloadTempFileInfo.files = res.data
        this.downloadTempFileInfo.total = res.total
      } catch (error) {
        console.error('获取文件列表失败:', error)
      }
    },
    _downLoadFile(file) {
      if (!file.tempUrl) {
        this.$message.error(this.$t('downloadTempFile.downloadFailed'))
        return
      }
      window.location.href = file.downloadUrl
    },
    _openDeleteFileModel(file) {
      this.$refs.deleteDialog.open(file)
    },
    _queryDownloadTempFileMethod() {
      this._listFiles(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.table-container {
  margin-top: 20px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>